import HttpFactory from 'http-service-v3'
export default function chatbotFactory() {
    const http = HttpFactory()
    return {
      async getThread(threadId) {
        return http
          .get(http.wsaDomain + `/chatbot/v1/ua/getthread/${threadId}`)
          .then(response => { return response.data })
      },
      async getThreads(visitorId) {
        return http
          .get(http.wsaDomain + `/chatbot/v1/ua/getthreads/${visitorId}`)
          .then(response => { return response.data })
      },
      async sendMessage(message){
        return http
          .post(http.wsaDomain + `/chatbot/v1/ua/sendmessage`, JSON.stringify(message))
      },
    }
  }